import Vue from "vue"
import authHeader from '../../util/auth-header'

const API_URL = "https://api.franqueados.codefysaas.com.br/api"

export default {
    login: (user) => {
        return Vue.http
        .post(API_URL + "/login", {
            email: user.email,
            password: user.password,
        })
        .then((response) => {
            localStorage.setItem('user', JSON.stringify(response.body))

            return response
        });
    },
    logout: () => {
        localStorage.removeItem("user")
    },
    refresh: () => {
        return Vue.http.post(API_URL + "/refresh", null, {
            headers: authHeader()
        }).then(response => {
            localStorage.setItem('user', JSON.stringify(response.body))
            
            return response
        }).catch(() => {
            Vue.router.push({ path: '/login' })
        })
    }
}
